// 结算管理
export default [
  {
    path: '/settlement',
    name: 'settlement',
    meta: { title: '结算管理' },
    component: () => import('../views/settlement/index'),
    children: [
      {
        path: '/settlement/platform',
        meta: { title: '平台明细', isMenu: true },
      },
      {
        path: '/settlement/platform/platformByProjectOrder',
        meta: { title: '项目订单列表', isMenu: true },
        component: () => import('../views/settlement/platformByProjectOrder'),
      },
      {
        path: '/settlement/platform/platformByProductOrder',
        meta: { title: '商品订单列表', isMenu: true },
        component: () => import('../views/settlement/platformByProductOrder'),
      },
      // 平台明细-商品订单-商品订单列表详情
      {
        path: '/settlement/detail/platformByProductOrderDetail',
        meta: { title: '商品订单明细详情' },
        component: () => import('../views/settlement/detail/platformByProductOrderDetail'),
      },


      {
        path: '/settlement/store',
        meta: { title: '门店明细', isMenu: true },
      },
      {
        path: '/settlement/store/storeByServiceList',
        meta: { title: '服务列表', isMenu: true },
        component: () => import('../views/settlement/storeByServiceList'),
      },
      {
        path: '/settlement/store/storeByProjectOrder',
        meta: { title: '项目订单列表', isMenu: true },
        component: () => import('../views/settlement/storeByProjectOrder'),
      },
      {
        path: '/settlement/store/storeByProductOrder',
        meta: { title: '商品订单明细', isMenu: true },
        component: () => import('../views/settlement/storeByProductOrder'),
      },
       // 门店明细-商品订单-商品订单明细详情
      {
        path: '/settlement/detail/storeByProductOrderDetail',
        meta: { title: '商品订单明细详情' },
        component: () => import('../views/settlement/detail/storeByProductOrderDetail'),
      },
      {
        path: '/settlement/withdrawalReview',
        meta: { title: '提现审核', isMenu: true },
        component: () => import('../views/settlement/withdrawalReview'),
      },
      {
        path: '/settlement/detail/withdrawalReviewDetail',
        meta: { title: '提现详情' },
        component: () => import('../views/settlement/detail/withdrawalReviewDetail'),
      },
      {
        path: '/settlement/commission',
        meta: { title: '员工提成明细', isMenu: true },
        component: () => import('../views/settlement/commission'),
      },
    ],
  },
];
